/* eslint-disable @typescript-eslint/indent */
import { TServerResponse } from 'app/types/server-response';

export enum AppUITheme {
  TRANSPORT = 'TRANSPORT',
  LOGISTICS = 'LOGISTICS',
  CHARTER_TRANSPORT = 'CHARTER_TRANSPORT',
  CHARTER_LOGISTICS = 'CHARTER_LOGISTICS',
  NA = 'NA',
}

export type TTaskStatus = 'idle' | 'pending';

export type TContactUsDTO = {
  title: string;
  customerId?: number;
  firstName: string;
  lastName: string;
  email: string;
  service: string;
  message: string;
};

export type TContactUsServerResponse = TServerResponse<
  TContactUsDTO & Record<'createdAt' | 'updatedAt', string>
>;
